
export default {
  name: 'userable',
  data: () => ({
    user: {
      email: null,
      organization_name: null,
    },
  }),
  methods: {
    cancel_user() {
      for (const name in this.computed_user) {
        this.user[name] = this.computed_user[name]
      }
    },
    async save_user() {
      this.$store.commit('user', JSON.parse(JSON.stringify(this.user)))
      this.$store.commit('lang', this.user.ui_language)
      await this.$communicator('update_user', {
        params: this.user
      })
      this.loading_settings_user = false;
      this.$toast.success("Success", {timeout: 2000});
    }
  },
  computed: {
    computed_user() {return this.$store.state.user},
    token() {return this.$store.state.token},
    access_rights_list() {return this.$store.state.access}
  },
  mounted() {
    this.organization = this.computed_user.services.length && this.computed_user.services[0].service_name ? this.computed_user.services[0].service_name : ""
    this.user = JSON.parse(JSON.stringify(this.computed_user))
  },
  watch: {
    'user.ui_language': {
      deep: true,
      handler() {
        this.$i18n.locale = (this.user && this.user.ui_language) ? this.user.ui_language.value : 'en'
      }
    }
  }
}
